export const visit = (vm, at) => {
at({ "en": { "data-token-views": { "propertyOnlyTokens": { "subscription_name": "Subscription type" }, "dataSensitivityTooltip": "This property stores sensitive information. It can't be used for personalization." } } });
};